//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { withAuthUser } from '@helpers/auth';
import { completedRegistration } from '@helpers/account';
import { withReferral } from '@helpers/referrals';
import { withTranslation } from 'react-i18next';

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class ViewRecommendationsButton extends React.Component {
  render() {
    const { __authUser, __referral, location, className, t } = this.props;
    if (
      !__authUser ||
      !completedRegistration(__authUser) ||
      !__referral ||
      !__referral.items ||
      __referral.items.length <= 0
    )
      return '';

    const componentClasses = classNames(styles.ViewRecommendationsButton, {
      [className]: className,
    });

    return (
      <Link
        to={{
          pathname: '/recommendation/review',
          state: { from: location, modal: true },
        }}
        className={componentClasses}
      >
        {t('dashboard_ViewRecommendation', { count: __referral.items.length })}{' '}
        ({__referral.items.length})
      </Link>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withRouter(
  withAuthUser(withReferral(withTranslation()(ViewRecommendationsButton)))
);
